<template>
  <div @click="toggleFavourite()">
    <md-icon>{{ check ? 'star' : 'star_border' }}</md-icon>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';

export default {
  name: "FavouriteButton",
  computed: {
    ...mapGetters('favourite', ['checkFavourite']),
    ...mapState('favourite', ['favouriteInitiated']),
    ...mapState('stopMenu', ['stopDetails']),
    check() {
      if (!this.favouriteInitiated) {
        this.getFavouriteList();
      }

      return this.checkFavourite(this.stopDetails);
    },
  },
  methods: {
    ...mapActions('favourite', ['getFavouriteList', 'addFavourite', 'removeFavourites']),
    toggleFavourite() {
      if (!this.check) {
        this.addFavourite(this.stopDetails);
      } else {
        this.removeFavourites(this.stopDetails);
      }

    },

  },

}
</script>

<style scoped>

</style>
